import React, { useEffect, useRef } from "react";
import { FaPhoneAlt } from "react-icons/fa";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

import "../About/Text.css";

gsap.registerPlugin(ScrollTrigger);

const Text = () => {
  const textRef = useRef(null);
  const imageRef = useRef(null);

  useEffect(() => {
    const textElements = textRef.current.querySelectorAll(
      ".paragraph-ll2, .heading-ll2, .subheading-ll2, .contact-container-ll2",
    );
    const imageElement = imageRef.current;

    // Animation for right-side content
    gsap.fromTo(
      textElements,
      { y: 0 }, // Start slightly below
      {
        y: 200, // Gradually move downward

        duration: 2, // Duration for smooth animation
        ease: "power3.out", // Smooth easing
        stagger: {
          each: 0.4, // Delay between text elements
        },
        scrollTrigger: {
          trigger: textRef.current,
          start: "top 85%", // Trigger when this section enters the viewport
          end: "bottom 20%", // Animation continues until this point
          scrub: 1, // Smooth animation tied to scroll progress
        },
      },
    );

    // Animation for left-side image
    gsap.fromTo(
      imageElement,
      { y: -80 }, // Start slightly above
      {
        y: 50, // Gradually move downward

        duration: 2, // Duration for smooth animation
        ease: "power2.out", // Softer easing
        scrollTrigger: {
          trigger: imageRef.current,
          start: "top 85%", // Trigger when this section enters the viewport
          end: "bottom 20%", // Animation continues until this point
          scrub: 1, // Smooth animation tied to scroll progress
        },
      },
    );
  }, []);

  return (
    <section className="leading-ll2">
      <div className="left-ll2" ref={imageRef}>
        <img
          src="/lawyer.webp"
          alt="Legal Service"
          className="left-image-ll2"
        />
      </div>
      <div className="right-ll2" ref={textRef}>
        <h1 className="heading-ll2">Leading Financial & Legal Advisors</h1>
        <p className="paragraph-ll2">
          We are a trusted firm offering expert legal and financial services to
          resolve your complex challenges. Our team of experienced professionals
          is committed to delivering high-quality, personalized solutions
          tailored to meet the diverse needs of our clients. Whether you require
          financial planning, corporate law advice, or legal counsel for
          personal matters, we are here to help.
        </p>
        <p className="paragraph-ll2">
          Our team consists of experts who not only excel in their fields but
          also understand the pressures financial and legal matters can bring.
          We prioritize your concerns, ensuring that you are well-informed and
          confident in the solutions we craft together. Our professionals
          collaborate closely with you to create strategies that align with your
          best interests.
        </p>

        <h4 className="subheading-ll2">
          Just call us. We can answer all your questions.
        </h4>
        <div className="contact-container-ll2">
          <div className="contact-info-ll2">
            <p className="contact-text-ll2">Contact with us</p>
            <p className="contact-number-ll2">+1 800-123-4567</p>
          </div>
          <FaPhoneAlt className="phone-icon-ll2" />
        </div>
      </div>
    </section>
  );
};

export default Text;
